var e = React.createElement;
import InfoBarHeader from "./InfoBarHeader";
import InfoBarHeaderMenu from "./InfoBarHeaderMenu";

export default class ChainObject extends React.Component {
    constructor(props) {
        super(props);
        this.saveAsFavorite = this.saveAsFavorite.bind(this);
        this.deleteObject = this.deleteObject.bind(this);
        this.editObject = this.editObject.bind(this);
        this.generateMenuItems = this.generateMenuItems.bind(this);
        this.contextMenu = this.contextMenu.bind(this);
        this.shortenString = this.shortenString.bind(this);
        this.menuItems = null;
        this.dataI18nKeys = ["source-object", "source-saved-as-favorite",
                               "source-save-as-favorite", "source-edit",
                                "source-delete"];
        this.setSelectedObject = this.setSelectedObject.bind(this);
        this.changeLogOfSelectedObject = this.changeLogOfSelectedObject.bind(this);
        this.editFormInfoBar = this.editFormInfoBar.bind(this);
        this.selectedChainIsPersonalOpinion = this.selectedChainIsPersonalOpinion.bind(
            this
          );
        this.objectInfoOfSelectedObject = this.objectInfoOfSelectedObject.bind(
            this
          );
        this.state = {
            selectedObject: null,
            showModal: false,
            modalHeader: "",
            modalContent: null,
            modalFooter: "",
            hideModalCloseIcon: false,
            hideShareButton: true,
            url: "",
            leftBar: this.initLeftBar,
            sourceCurrentInfoData: "",
            isSourceExpanded: false,
            isReferenceNumberExpanded: false,
            isReferenceExpanded: false
          };
    }

    changeLogOfSelectedObject() {
        const viewId = this.props.selectedObject.viewId;
        const type = this.props.selectedObject.type;
        const id = this.props.selectedObject.id;
        var changeLog = [];
        if (type === globalFunctions.objectTypes.OBJECT) {
          changeLog = this.props.object.changeLog.filter((change) => {
            if (change.fields && typeof change.fields.chainId !== "undefined") {
              return false;
            }
            return true;
          });
        } else if (type === globalFunctions.objectTypes.SOURCE) {
          this.props.object.chains.some((chain) => {
            return chain.sources.some((source) => {
              if (source.viewId === viewId) {
                changeLog = source.changeLog;
                return true;
              }
              return false;
            });
          });
        } else if (type === globalFunctions.objectTypes.REFERENCE_NO) {
          this.props.object.referencePoint.filter((value) => {
            if(value.changeLog.length && value.viewId === viewId) {
               changeLog = value.changeLog;
               return true;
            }else{
              return false;
            }
          });
        }
        return changeLog;
    }

    getSelectedObject(key) {
        return this.state.selectedObject && this.state.selectedObject[key];
      }

    selectedChainIsPersonalOpinion() {
        if (this.state.selectedObject === null) {
          return null; // currently no object is selected
        }
        if (
          this.state.selectedObject.type !==
            globalFunctions.objectTypes.REFERENCE &&
          this.state.selectedObject.type !==
            globalFunctions.objectTypes.REFERENCE_NO
        ) {
          return -1; // not reference
        }
        if (
          this.state.selectedObject.type ===
            globalFunctions.objectTypes.REFERENCE ||
          this.state.selectedObject.type ===
            globalFunctions.objectTypes.REFERENCE_NO
        ) {
          if (this.props.object.typeId === 5) {
            return 1; // reference and personal opinion
          }
          return 0; // reference but not personal opinion
        }
      }

    editFormInfoBar() {
        var onChainFormResolved = (response) => {
          var extraInputs =
            '<input type="hidden" name="objectId" value="' +
            this.props.object.id +
            '">' +
            '<input type="hidden" name="referenceType" value="' +
            this.props.object.typeId +
            '">' +
            '<input type="hidden" name="chainId" value="' +
            this.state.selectedObject.id +
            '">' +
            '<button id="add-chain" class="ui button" type="button">Update</button>';
          if (response.isForm) {
            var reference = globalFunctions.getTranslatedMessage(
              this.dataI18nKeys[4],
              "Reference"
            );
            $("#sub-title-form-object").html(reference);
            $("#object-form").html(response.data + extraInputs);
          }
          this.afterFetchForm();
        };
        var isPO = this.selectedChainIsPersonalOpinion();
        return isPO !== null // an object is selected
          ? isPO === -1 // not reference
            ? () =>
                this.fetchEditForm(
                  this.state.selectedObject.id,
                  this.state.selectedObject.viewId
                )
            : isPO === 1 // reference and personal opinion
            ? () => undefined
            : () =>
                this.fetchChainForm(
                  this.props.object.typeId,
                  this.state.selectedObject.id
                ).then(onChainFormResolved, (rejected) =>
                  console.log("Rejected = ", rejected)
                )
          : () => undefined;
      }

    objectInfoOfSelectedObject() {
        const viewId = this.props.selectedObject.viewId;
        const type = this.props.selectedObject.type;
        const objectInfo = {};
        objectInfo.type = type;
        switch (type) {
          case globalFunctions.objectTypes.OBJECT:
            objectInfo.actualObjectData = Object.assign(
              {},
              this.props.object.actualObjectData
            );
            objectInfo.objectData = Object.assign({}, this.props.object.objectData);
            var keys = Object.keys(objectInfo.actualObjectData);
            delete objectInfo.actualObjectData[keys[keys.length - 1]];
            break;
          case globalFunctions.objectTypes.SOURCE:
            this.props.object.chains.some((chain) => {
              return chain.sources.some((source) => {
                if (source.viewId === viewId) {
                  objectInfo.sourceData = Object.assign({}, source.sourceData);
                  objectInfo.reference = Object.assign({}, source.reference);
                  return true;
                }
                return false;
              });
            });
            break;
          case globalFunctions.objectTypes.REFERENCE:
            this.props.object.referencePoint.some((refPoint) => {
              if (refPoint.viewId === viewId) {
                objectInfo.referenceData = {};
                objectInfo.referenceData.viewId = refPoint.viewId;
                objectInfo.referenceData.title = refPoint.title;
                objectInfo.referenceData.value = refPoint.value;
                return true;
              }
              return false;
            });
            break;
        }
        return objectInfo;
      }

    deleteObjectInfoBar() {
        var isPO = this.selectedChainIsPersonalOpinion();
        var selectedSourceType = this.getSelectedObject("type");
        return isPO !== null // an object is selected
          ? isPO === -1 // not reference
            ? (selectedSourceType !== globalFunctions.objectTypes.OPEN_POINT && selectedSourceType !== globalFunctions.objectTypes.END_POINT) ?
                () =>
                this.deleteObject(
                  this.state.selectedObject.id,
                  this.state.selectedObject.type ===
                    globalFunctions.objectTypes.SOURCE
                )
                : () => this.deleteEndPoint()
            : () => this.deleteChain(this.state.selectedObject.id)
          : () => undefined;
      }


    saveAsFavorite() {
        this.props.saveAsFavorite();
    }

    deleteObject() {
        this.props.delete(this.props.object.id, false);
    }

    editObject() {
        this.props.fetchForm(this.props.object.id, this.props.object.viewId);
    }

    generateMenuItems(){
        this.menuItems = [];
        var isOwner = this.props.isOwner;
        var data = this.props.data;
        var objectInfo = this.props.object;

        this.menuItems.push(<li key={objectInfo.viewId + "-menu-header"} className="header">Id: {objectInfo.viewId}</li>);
        if(isOwner){
            this.menuItems.push(<li key={objectInfo.viewId + "-edit"} className="item display-edit-object-form" onClick={this.editObject}>
                                        <i className="pencil icon custom-font-size"></i>
                                        <span data-i18n={this.dataI18nKeys[3]}>Edit</span>
                                </li>);
            this.menuItems.push(<li key={objectInfo.viewId + "-delete"} className="item" onClick={this.deleteObject}>
                                    <i className="trash alternate outline icon custom-font-size"></i>
                                    <span data-i18n={this.dataI18nKeys[4]}>Delete</span>
                                </li>);
        }
        else{
            this.menuItems.push(<div key={objectInfo.viewId + "-save-as-favorite"} className="item" id="save-as-favorite-menu-item" onClick={this.saveAsFavorite}>
                                        <i className= {"save" + (this.props.object.isSavedAsFavorite ? "" : " outline ") + " icon custom-font-size"}></i>
                                        {this.props.object.isSavedAsFavorite
                                                ? <span data-i18n={this.dataI18nKeys[1]}>
                                                    Saved as favorite
                                                    </span>
                                                    : <span data-i18n={this.dataI18nKeys[2]}>
                                                        Save as favorite
                                                    </span>}
                                    </div>);
        }
    }

    componentDidMount(){
        for(var key in this.dataI18nKeys){
            globalFunctions.applyTranslatedMessage(this.dataI18nKeys[key],
                                "[data-i18n=" + this.dataI18nKeys[key] + "]");
        }
    }

    contextMenu(e){
        e.preventDefault();
        $(e.target).parents(".object-div").find(".context-menu")
                    .toggle(0, function () {
                        $(this).css({ maxHeight: "114px" });
                        var parentOffset = $(e.target).offset();
                        var parentHeight =  $(e.target).height();
                        var mousePointer = e.pageY < parentOffset.top
                                                ? parentOffset.top - e.pageY
                                                : e.pageY - parentOffset.top;
                        var heightOfMenu = $(this).height();
                        var top = 0;

                        if ((parentHeight - mousePointer) > heightOfMenu) {	//there's enough space below
                            top = mousePointer;
                        } else if (mousePointer > heightOfMenu) {	//there's enough space above
                            top = mousePointer - heightOfMenu;
                        } else {	//there's neither enough space above nor below, so we'll place the menu wherever there is more room available
                            if ((parentHeight - mousePointer) > mousePointer) {	//there's more room available below
                                $(this).css({maxHeight: "114px"});
                                top = mousePointer;
                            } else {	//there's more room available above
                                $(this).css({maxHeight: "114px"});
                                top = 0;
                            }
                        }


                        var left = e.screenX - parentOffset.left;

                        $(this).css({top: top  + "px", left: left + "px"});
                    });
    }

    setSelectedObject(e) {
      if(this.props.isLoggedIn == 1){
      $('#infobar #selected-object-id_Edit').removeClass('hide');
      $('#infobar #selected-object-id_Delete').removeClass('hide');
      $('#infobar #selected-object-id_Edit').addClass('show');
      $('#infobar #selected-object-id_Delete').addClass('show');
      }
        e.stopPropagation();
        window.history.replaceState(window.location.href,'ObjURL',this.props.object.viewId);

        this.props.setSelectedObject({
            viewId: this.props.object.viewId,
            id: this.props.object.id,
            type: globalFunctions.objectTypes.OBJECT
        });
    }

    shortenString(str) {
        return (typeof str === "string" && str.length > 30)
                ? str.substring(0, 30).trim() + ".."
                : str;
    }



    render() {
        var isOwner = this.props.object.isOwner;
        this.generateMenuItems();
        let selectedBlock = "";
        if(this.props.object.viewId === this.props.selectedObjectId){
            selectedBlock = "selected ";
        }

        // console.log(this.props.object.viewId);
        return(
        <div class="innerLeft">
          {this.props.object.viewId ===( this.props.selectedObject && this.props.selectedObject.viewId) && 
                       <InfoBarHeaderMenu
                            selectedObject={this.props.selectedObject}
                            showModal={this.props.showModal}
                            changeLog={this.changeLogOfSelectedObject()}
                            fetchEditForm={this.props.fetchEditFormMenu}
                            objectInfo={this.objectInfoOfSelectedObject()}
                            hideEdit={
                              !this.props.object.isOwner ||
                              this.selectedChainIsPersonalOpinion() === 1
                            }
                            isOwner={isOwner}
                            isLoggedIn={this.props.object.isLoggedIn}
                            performDelete={this.props.delete}
                            saveAsFavorite={this.saveAsFavorite}
                            isSavedAsFavorite={this.props.object.isSavedAsFavorite}
                            isPublished={this.props.object.actualObjectData.is_published}
                          />
                        }
                <div onContextMenu={this.contextMenu}
                        className={selectedBlock+"selected-wrap object-div main-object inner-line" + (this.props.applyNoAfter ? " no-after" : "")}
                        onClick={this.setSelectedObject}
                        id="chain-object"
                        >
                          
                        {/* <h5>{this.props.object.type}</h5> */}
                        <h5>{this.props.object.actualObjectData['Type of book'] === 'eBook' ? 'Ebook' : this.props.object.type}</h5>
                        <div className="info-div">
                            {
                                Object.keys(this.props.object.attributes)
                                    .map( (key, index) =>
                                (
                                    <p key={"attr-" + index}>
                                        {this.shortenString(this.props.object.attributes[key])}
                                    </p>
                                ))
                            }
                        </div>
                        {
                            this.props.object.viewId === this.props.selectedObjectId
                            && <hr className="selected-source" />
                        }
                        <div className="context-dropdown-container">
                            <div className="ui scrolling dropdown">
                                <ul className='context-menu menu'>
                                    {this.menuItems}
                                </ul>
                            </div>
                        </div>
                    </div>
                  </div>
                );
    }
}


// WEBPACK FOOTER //
// ./frontend/web/js/ChainObject.js